import React from "react";
import { serviceList } from "./ServiceList";
import { observer } from "mobx-react-lite";

function Service() {
  return (
    <div id="service" className="container py-5">
      {/* Section Title */}
      <div className="section-title mb-5" data-aos="fade-up">
        <h5 className="text-center fw-bold f-upper">Our Services</h5>
      </div>

      {/* Service Grid */}
      <div className="row g-4">
        {serviceList.map((item: any, i: any) => (
          <div key={i} className="col-12 col-sm-6 col-lg-4" data-aos="fade-up">
            <div className="card border-0 shadow-sm servicebox text-center position-relative h-100">
              <div className="position-relative overflow-hidden rounded-top">
                <img
                  src={item.image}
                  alt="karnafully"
                  className="img-fluid w-100"
                  style={{
                    height: "250px",
                    objectFit: "cover",
                    borderRadius: "10px 10px 0 0",
                  }}
                />
              </div>

              <div className="card-body px-3 py-4">
                <div className="icon mx-auto mb-3">{item.icon}</div>
                <h5 className="fw-bold mb-3">{item.title}</h5>
                <p
                  className="text-muted"
                  style={{
                    textAlign: "justify",
                    fontSize: "0.95rem",
                    minHeight: "90px",
                  }}
                >
                  {item.body.length > 150
                    ? item.body.substring(0, 150) + "..."
                    : item.body}
                </p>
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm fw-semibold mt-2"
                  data-bs-toggle="modal"
                  data-bs-target={`#exampleModal${i}`}
                >
                  EXPLORE
                </button>
              </div>
            </div>

            {/* Modal */}
            <div
              className="modal fade"
              id={`exampleModal${i}`}
              tabIndex={-1}
              aria-labelledby={`exampleModalLabel${i}`}
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5
                      className="modal-title fw-bold"
                      id={`exampleModalLabel${i}`}
                    >
                      {item.title}
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body text-start">
                    <p>{item.body}</p>
                    <ul>
                      {item.points.map((point: any, j: any) => (
                        <li key={j} style={{ listStyleType: "square" }}>
                          {point}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* View More */}
      <div className="text-center mt-5">
        <a href="#" className="fw-bold text-decoration-none view-more">
          View More →
        </a>
      </div>
    </div>
  );
}

export default observer(Service);
